import type * as React from 'react'

import { styled } from 'styled-components'

import {
  Button,
  Spinner,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'

type ShowResultsProps = {
  loading: boolean
  onSubmit: () => void
  results: string
  hasError?: boolean
}

const StSpinner = styled(Spinner)`
  &&& {
    margin: 0 0.4rem;
  }
`

const TextContainer = styled.div`
  margin-right: 0.4rem;
`

const ShowResultsButton: React.FC<ShowResultsProps> = ({
  loading,
  onSubmit,
  results,
  hasError = false,
}) => {
  let showResultsText

  if (!loading && !results) {
    showResultsText = (
      <FormattedMessage
        id="Filters.MobileSearchFilters.actions.submit.simple"
        values={{
          results,
        }}
      />
    )
  } else if (loading) {
    showResultsText = (
      <FormattedMessage id="Filters.MobileSearchFilters.actions.submit.loading" />
    )
  } else {
    showResultsText = (
      <FormattedMessage
        id="Filters.MobileSearchFilters.actions.submit"
        values={{
          results,
        }}
      />
    )
  }

  return (
    <Button onClick={onSubmit} disabled={hasError}>
      <TextContainer>{showResultsText}</TextContainer>
      {loading && <StSpinner size="12px" padding="0" text="" />}
    </Button>
  )
}

export default ShowResultsButton
